import React, { Component } from 'react';
import 'react-day-picker/lib/style.css';
import CompanyVersions from '../Services/XenioUpdates/xenioUpdates';
import { faPlusCircle, faTrash, faExclamationTriangle } from '../../node_modules/@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Badge } from 'reactstrap';
import XenioUpdatesService from '../Services/XenioUpdates/xenioUpdates';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { css } from 'react-emotion';
// First way to import
import { ClipLoader } from 'react-spinners';
import { Redirect } from 'react-router-dom';
import MainLayout from '../layout/layout';
import RolesType from '../utils/roles';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

class CompanyVersion extends Component {

    constructor(props) {
        super();
        this.state = {
            Data: { DataPending: false, DataValue: [] },
            TypeList: [],
            VersionNameList: [],
            totalCount: 0,
            page: 1,
            maxPerPage: 10,
            divWidth: {
                width: 30000
            },
            className: "custom-dialog",
            Filter: {
                FilterCompanyCode: "",
                FilterVersion: null
            },
            SelectType: "",
            SelectVersionName: "",
            SelectCompanyCode: "",
            modal: { warning: false, id: null, success: false, add: false },
            Button: <Button color="btn btn-success">OK</Button>,
            loading: false,
            isAutenticated: true,
        };
        this.companyCodeValueV = this.companyCodeValueV.bind(this);
        this.toggleAdd = this.toggleAdd.bind(this);
        this.toggleWarning = this.toggleWarning.bind(this);
        this.handleChangeVersion = this.handleChangeVersion.bind(this);
        this.handleChangeVersionName = this.handleChangeVersionName.bind(this);
        this.hanldeCompanyCode = this.hanldeCompanyCode.bind(this);
        this.hanldeKeyPress = this.hanldeKeyPress.bind(this);
    }
    hanldeKeyPress(e) {
        //var company =this.state.Filter.FilterCompanyCode;
        if (e.keyCode === 13) {
            // if(company !== "")
            // {
            this.getAll(1, 10, this.state.Filter.FilterCompanyCode);
            // }else{
            //     toast.warning("You must to select a Company Code!", { className: {
            //         opacity: 0.8
            //     }});
            // }           
        }
    }
    componentDidMount() {

        this.getAllType();
        this.getAll(this.state.page, this.state.maxPerPage, this.state.Filter.FilterCompanyCode);
    }
    companyCodeValueV(e) {
        e.preventDefault();
        let stateCopy = Object.assign({}, this.state);
        stateCopy.Filter.FilterCompanyCode = e.target.value;
        this.setState(stateCopy);
    }
    getAllType() {
        let dataResult = CompanyVersions.getAllUpdateType();
        var that = this;
        let stateCopy = Object.assign({}, that.state);
        dataResult.then(function (data) {
            data.data.map((elem) => {
                stateCopy.TypeList.push({ ID: elem.ID, Name: elem.Name })
                return console.log();
            });
        }).catch((error) => {

            if (error.response) {
                if (error && error.response && error.response.data.Message === "500") {
                    toast.error("Error Data Base(Error: 500)", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NotReseller") {
                    toast.error("This User does not have permission!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data.Message === "400") {
                    toast.error("API Error for Reseller", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error.response.status === 401) {
                    sessionStorage.setItem("user", '');
                    sessionStorage.setItem("token", '');
                    sessionStorage.setItem("rol", '');
                    sessionStorage.setItem("email", '');
                    sessionStorage.clear();
                    this.setState({ isAutenticated: false },
                        () => {
                            this.forceUpdate();
                        })
                }
            } else {
                toast.error("Code Error", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        });
    }
    SearchCompanyVersion() {

        var CompanyCode = this.state.Filter.FilterCompanyCode;
        if (CompanyCode) {
            this.getAll(this.state.page, this.state.maxPerPage, CompanyCode);
        } else {
            toast.warning("You must to select a Company Code!", {
                className: {
                    opacity: 0.8
                }
            });
        }
    }
    SearchCompanyVersionByCompanyCode(CompanyCode) {
        if (CompanyCode) {
            this.getAll(this.state.page, this.state.maxPerPage, CompanyCode);
        } else {
            toast.warning("You must to select a Company Code!", {
                className: {
                    opacity: 0.8
                }
            });
        }
    }
    getAll(page, maxPerPage, CompanyCode) {

        var email = sessionStorage.getItem('email');

        this.setState({
            Data: { DataPending: true, DataValue: [] },
            totalCount: 0,
            page: 1
        });
        // if(CompanyCode === null || CompanyCode === "" || CompanyCode === undefined)
        // {
        //     this.setState({
        //         Data: { DataPending: false, DataValue: [] },
        //         totalCount: 0,
        //         page: 1
        //     });
        //     toast.warning("You must to select a Company Code!", { className: {
        //         opacity: 0.8
        //     }});
        //     return false;
        // }
        let dataResult = CompanyVersions.getAllCompanyVersions(page, maxPerPage, CompanyCode, email);
        var that = this;
        dataResult.then(function (data) {
            that.setState({
                Data: { DataPending: false, DataValue: data.data.Logs },
                totalCount: parseInt(data.data.Log_Total_Count, 10),
                page: data.data.npage
            });
        }).catch((error) => {

            that.setState({
                Data: { DataPending: false, DataValue: [] },
                totalCount: 0,
                page: 1
            });
            if (error.response) {
                if (error && error.response && error.response.data.Message === "500") {
                    toast.error("Error Data Base(Error: 500)", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NotReseller") {
                    toast.error("This User does not have permission!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data.Message === "400") {
                    toast.error("API Error for Reseller", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error.response.status === 401) {
                    sessionStorage.setItem("user", '');
                    sessionStorage.setItem("token", '');
                    sessionStorage.setItem("rol", '');
                    sessionStorage.setItem("email", '');
                    sessionStorage.clear();
                    this.setState({ isAutenticated: false },
                        () => {
                            this.forceUpdate();
                        })
                }
            } else {
                toast.error("Code Error", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        });
    }
    toggleAdd(id) {
        this.setState({
            modal: { warning: false, id: id, success: false, add: !this.state.modal.add },
            SelectCompanyCode: "",
            SelectType: "",
            SelectVersionName: "",
            VersionNameList: []
        });
    }
    toggleWarning(id) {
        this.setState({
            modal: { warning: !this.state.modal.warning, id: id, success: false, add: false }
        });
    }
    setOperationCompanyVersions(a, id, operations) {
        if (operations === "DELETE") {
            this.setState({
                Button: <a className="btn btn-warning" onClick={(e) => { this.DeleteDeviceUpdate(e, id) }}>OK</a>,
                loading: false
            });
            this.toggleWarning(id);
        } else if (operations === "ADD") {
            this.setState({
                Button: <a className="btn btn-success" onClick={(e) => { this.AddCompanyVersion(e, id) }}>OK</a>,
                loading: false
            });
            this.toggleAdd(id);
        }
    }
    DeleteDeviceUpdate(e, id) {

        var email = sessionStorage.getItem('email');
        var List = this.state.Data.DataValue;
        var CompanyCode = List.find(x => x.ID === id);
        var that = this;
        var result = XenioUpdatesService.DeleteDeviceUpdate(id, CompanyCode.CompanyCode, email);
        that.setState({
            loading: true,
            Button: <a className="btn btn-warning disabled" onClick={(e) => { this.SaveBackup(e) }} disabled >OK</a>
        });
        result.then(function (data) {
            if (data.data === "OK") {
                that.setState({
                    modal: { success: false, id: null, add: false, warning: false },
                    loading: false
                });
                //that.SearchCompanyVersionByCompanyCode(CompanyCode.CompanyCode);
                that.getAll(1, 10, that.state.Filter.FilterCompanyCode);
                toast.success("Deleted!", {
                    className: {
                        opacity: 0.8
                    }
                });
            } else if (data.data === "Empty") {
                that.setState({
                    modal: { success: false, id: null, add: false, warning: false },
                    loading: false
                });
                //that.SearchCompanyVersionByCompanyCode(CompanyCode.CompanyCode);
                that.getAll(1, 10, that.state.Filter.FilterCompanyCode);
                toast.error("Not Exist!", {
                    className: {
                        opacity: 0.8
                    }
                });
            } else if (data.data === "No") {
                that.setState({
                    modal: { success: false, id: null, warning: false },
                    loading: false
                });
                toast.error("Not Deleted!", {
                    className: {
                        opacity: 0.8
                    }
                });
            } else if (data.data === "AuditError") {
                that.setState({
                    modal: { success: false, id: null, warning: false },
                    loading: false
                });
                toast.error("Not Deleted!", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        }).catch((error) => {
            that.setState({
                modal: { success: false, id: null },
                SelectCompanyCode: "",
                SelectType: "",
                SelectVersionName: "",
                loading: false
            });
            if (error.response) {
                if (error && error.response && error.response.data.Message === "500") {
                    toast.error("Error Data Base(Error: 500)", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NotReseller") {
                    toast.error("This User does not have permission!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data.Message === "400") {
                    toast.error("API Error for Reseller", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error.response.status === 401) {
                    sessionStorage.setItem("user", '');
                    sessionStorage.setItem("token", '');
                    sessionStorage.setItem("rol", '');
                    sessionStorage.setItem("email", '');
                    sessionStorage.clear();
                    this.setState({ isAutenticated: false },
                        () => {
                            this.forceUpdate();
                        })
                }
            } else {
                toast.error("Code Error", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        });
    }
    AddCompanyVersion(e) {
        e.preventDefault();
        var CompanyCode = this.state.SelectCompanyCode;
        var VersionName = this.state.SelectVersionName;
        var TypeID = this.state.SelectType;
        var email = sessionStorage.getItem('email');

        if (CompanyCode === "" || VersionName === "" || TypeID === "") {
            toast.warning("CompanyCode and Version can not be empty!", {
                className: {
                    opacity: 0.8
                }
            });
        } else {
            var result = XenioUpdatesService.AddCompanyVersion(CompanyCode, VersionName, TypeID, email);
            var that = this;
            that.setState({
                loading: true,
                Button: <a className="btn btn-success disabled" onClick={(e) => { this.AddCompanyVersion(e) }} >OK</a>
            });
            result.then(function (data) {
                if (data.data === "OK") {
                    that.setState({
                        modal: { success: false, id: null, add: false },
                        SelectCompanyCode: "",
                        SelectType: "",
                        SelectVersionName: "",
                        loading: false,
                        FilterCompanyCode: CompanyCode
                    });
                    //that.SearchCompanyVersionByCompanyCode(CompanyCode);
                    that.getAll(1, 10, that.state.Filter.FilterCompanyCode);
                    toast.success("Saved!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (data.data === "Exist") {
                    that.setState({
                        loading: false,
                        Button: <a className="btn btn-success" onClick={(e) => { that.AddCompanyVersion(e) }} >OK</a>
                    });
                    toast.error("This already exist!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (data.data === "No") {
                    that.setState({
                        modal: { success: false, id: null },
                        SelectCompanyCode: "",
                        SelectType: "",
                        SelectVersionName: "",
                        loading: false
                    });
                    toast.error("Not Saved!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (data.data === "AuditError") {
                    that.setState({
                        modal: { success: false, id: null },
                        SelectCompanyCode: "",
                        SelectType: "",
                        SelectVersionName: "",
                        loading: false
                    });
                    toast.error("Not Saved!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                }
            }).catch((error) => {

                that.setState({
                    modal: { success: false, id: null },
                    SelectCompanyCode: "",
                    SelectType: "",
                    SelectVersionName: "",
                    loading: false
                });
                if (error.response) {
                    if (error && error.response && error.response.data.Message === "500") {
                        toast.error("Error Data Base(Error: 500)", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    } else if (error && error.response && error.response.data === "NoDB") {
                        toast.error("Company Code dosen't exist!", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    } else if (error && error.response && error.response.data === "NotReseller") {
                        toast.error("This User does not have permission!", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    } else if (error && error.response && error.response.data.Message === "400") {
                        toast.error("API Error for Reseller", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    } else if (error.response.status === 401) {
                        sessionStorage.setItem("user", '');
                        sessionStorage.setItem("token", '');
                        sessionStorage.setItem("rol", '');
                        sessionStorage.setItem("email", '');
                        sessionStorage.clear();
                        this.setState({ isAutenticated: false },
                            () => {
                                this.forceUpdate();
                            })
                    }
                } else {
                    toast.error("Code Error", {
                        className: {
                            opacity: 0.8
                        }
                    });
                }
            });
        }
    }
    hanldeCompanyCode(e) {
        e.preventDefault();

        var value = e.target.value;
        this.setState({
            SelectCompanyCode: value
        });
    }
    handleChangeVersion(event) {

        var value = event.target.value;
        this.setState({
            SelectType: value,
            Filter: { FilterVersion: value }
        }, () => this.getAllVersionByType());
    }
    handleChangeVersionName(event) {

        var value = event.target.value;
        this.setState({
            SelectVersionName: value
        }, () => console.log());
    }
    getAllVersionByType() {

        var CompanyCode = 1
        var UpdateID = this.state.SelectType;

        if (UpdateID !== "" && UpdateID !== undefined && UpdateID !== null) {
            var DataUpdateTypeResult = CompanyVersions.getAllUpdateVersion(CompanyCode, UpdateID);
            var that = this;
            DataUpdateTypeResult.then(function (data) {
                that.setState({
                    VersionNameList: data.data
                });
            }).catch((error) => {
                if (error.response) {
                    if (error && error.response && error.response.data.Message === "500") {
                        toast.error("Error Data Base(Error: 500)", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    } else if (error && error.response && error.response.data === "NoDB") {
                        toast.error("Company Code dosen't exist!", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    } else if (error && error.response && error.response.data === "NotReseller") {
                        toast.error("This User does not have permission!", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    } else if (error && error.response && error.response.data.Message === "400") {
                        toast.error("API Error for Reseller", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    } else if (error.response.status === 401) {
                        sessionStorage.setItem("user", '');
                        sessionStorage.setItem("token", '');
                        sessionStorage.setItem("rol", '');
                        sessionStorage.setItem("email", '');
                        sessionStorage.clear();
                        this.setState({ isAutenticated: false },
                            () => {
                                this.forceUpdate();
                            })
                    }
                } else {
                    toast.error("Code Error", {
                        className: {
                            opacity: 0.8
                        }
                    });
                }
            });
        } else {
            this.setState({
                VersionNameList: []
            }, () => console.log());
        }
    }
    renderPages() {

        let pages = [];
        let pagesCount = parseInt(this.getPagesCount(this.state.maxPerPage), 10);
        let pagesShow = pagesCount > 5 ? 5 : this.getPagesCount(this.state.maxPerPage);
        let startPagination = pagesCount <= 5 ? 1 : (this.state.page - 3 <= 0 ? 1 : (this.state.page + 2 > pagesCount ? pagesCount - 4 : this.state.page - 2));
        for (let i = startPagination; i <= startPagination + pagesShow - 1; i++) {
            pages.push(<li key={i} className={this.state.page === i ? "page-item active" : "page-item"} onClick={(event) => {
                event.preventDefault(); this.getAll(i, this.state.maxPerPage, this.state.Filter.FilterCompanyCode)
            }}><a className="page-link">{i}</a></li>);
        }
        return pages
    }
    renderNextPage() {
        let next_page = this.getNextPage(this.state.page, this.state.maxPerPage);
        let pagesCount = parseInt(this.getPagesCount(this.state.maxPerPage), 10);
        let nextpages = [];
        if (next_page !== 0) {
            nextpages.push(<li key="Next" className="page-item" onClick={(event) => {
                event.preventDefault(); this.getAll(next_page, this.state.maxPerPage, this.state.Filter.FilterCompanyCode)
            }}>
                <a className="page-link" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                </a>
            </li>);
            nextpages.push(<li key="Last" className="page-item" onClick={(event) => {
                event.preventDefault(); this.getAll(pagesCount, this.state.maxPerPage, this.state.Filter.FilterCompanyCode)
            }}>
                <a className="page-link" aria-label="Last">
                    <span aria-hidden="true">Last</span>
                </a>
            </li>);

        } else {
            nextpages.push(<li key="NextP" className="page-item disabled">
                <a className="page-link" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                </a>
            </li>);
            nextpages.push(<li key="LastP" className="page-item disabled">
                <a className="page-link" aria-label="Last">
                    <span aria-hidden="true">Last</span>
                </a>
            </li>);
        }
        return nextpages;
    }
    renderFirstPage() {
        let prev_page = this.getPrevPage(this.state.page, this.state.maxPerPage);
        let prevpages = [];
        if (prev_page !== 0) {
            prevpages.push(<li key="FirstT" className="page-item" onClick={(event) => {
                event.preventDefault(); this.getAll(1, this.state.maxPerPage, this.state.Filter.FilterCompanyCode)
            }}>
                <a className="page-link" aria-label="First">
                    <span aria-hidden="true">First</span>
                </a>
            </li>);
            prevpages.push(<li key="FirstTT" className="page-item" onClick={(event) => {
                event.preventDefault(); this.getAll(prev_page, this.state.maxPerPage, this.state.Filter.FilterCompanyCode)
            }}>
                <a className="page-link" aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                </a>
            </li>);
        } else {
            prevpages.push(<li key="FirstPP" className="page-item disabled">
                <a className="page-link" aria-label="First">
                    <span aria-hidden="true">First</span>
                </a>
            </li>);
            prevpages.push(<li key="FirstPPP" className="page-item disabled">
                <a className="page-link" aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                </a>
            </li>);
        }
        return prevpages;
    }
    getPrevPage(currentPage, maxPerPage) {
        if (parseInt(maxPerPage >= this.state.totalCount, 10))
            return 0;
        else
            return currentPage - 1;
    }
    getNextPage(currentPage, maxPerPage) {
        if (parseInt(this.state.totalCount / maxPerPage, 10) === currentPage && parseInt(this.state.totalCount % maxPerPage, 10) === 0)
            return 0;
        else if (parseInt(this.state.totalCount / maxPerPage, 10) === currentPage - 1 && parseInt(this.state.totalCount % maxPerPage, 10) > 0)
            return 0;
        else
            return currentPage + 1;
    }
    getPagesCount(maxPerPage) {
        if (parseInt(this.state.totalCount % maxPerPage, 10) > 0)
            return (this.state.totalCount / maxPerPage) + 1;
        else
            return this.state.totalCount / maxPerPage;
    }
    renderCompanyVersionRow() {

        let dataResult = RolesType;

        var temp = Object.keys(dataResult);

        if (sessionStorage.getItem("rol") === temp[0] || sessionStorage.getItem("rol") === temp[1] || sessionStorage.getItem("rol") === temp[2] || sessionStorage.getItem("rol") === temp[3] || sessionStorage.getItem("rol") === temp[4] ||
            sessionStorage.getItem("rol") === temp[5]) {
            return <div>
                <div className="row">
                    <div className="col s12">
                        <div className="card Logs">
                            <div className="card-header">
                                <div className="row" id="timelogs_filter">
                                    {/* <div className="col-3">                 
                                            <h4><span className="badge badge-info">Company Versions</span></h4>                             
                                        </div> */}
                                    <div className="col-lg-2 col-md-2 col-sm-2">
                                        <label className="control-label" style={{ 'paddingTop': '15px', 'fontWeight': 'bold' }}>Company Code</label>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-3">
                                        <div className="form-group" style={{ 'paddingTop': '7px' }}>
                                            <input className="form-control" name="companycodeV" id="companycodeV" type="text" onKeyDown={this.hanldeKeyPress} onChange={this.companyCodeValueV} value={this.state.Filter.FilterCompanyCode ? this.state.Filter.FilterCompanyCode : ""} />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-3">
                                        <div className="form-group">
                                            {/* <Button color="info" style={{ 'padding': '0.6rem 1.14rem' }} onClick={this.SearchCompanyVersion}  ><FontAwesomeIcon icon={faSearch} />&nbsp;&nbsp;Search</Button> */}
                                            <a className="btn btn-success" style={{ 'padding': '0.6rem 1.14rem' }} onClick={(e) => this.setOperationCompanyVersions(e, "", 'ADD')}><FontAwesomeIcon icon={faPlusCircle} />&nbsp;&nbsp;Create</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <table className="table table-hover table-striped table-sm myTable">
                                    <thead>
                                        <tr>
                                            <th scope="col" style={{ 'fontWeight': 'bold' }}>Company Code</th>
                                            <th scope="col" style={{ 'fontWeight': 'bold' }}>Type</th>
                                            <th scope="col" style={{ 'fontWeight': 'bold' }}>Version Name</th>
                                            <th scope="col"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.Data.DataValue.length > 0
                                                ?
                                                this.state.Data.DataValue.map((item, index) => {
                                                    return <tr key={index}>
                                                        <td style={{ 'fontWeight': 'normal' }}>{item.CompanyCode}</td>
                                                        <td style={{ 'fontWeight': 'normal' }}>{item.Type}</td>
                                                        <td style={{ 'fontWeight': 'normal' }}>{item.UpdateVersionName}</td>
                                                        <td>
                                                            <h6>
                                                                <a onClick={(e) => { this.setOperationCompanyVersions(e, item.ID, "DELETE") }}><Badge color="danger"><FontAwesomeIcon icon={faTrash} /></Badge></a>
                                                            </h6>
                                                        </td>
                                                    </tr>;
                                                })
                                                :
                                                <tr><td colSpan="13"><div style={{ 'textAlign': 'center', 'fontWeight': 'normal' }}>No records.</div></td></tr>
                                        }
                                    </tbody>
                                </table>
                                <nav aria-label="Page navigation example">
                                    <ul className="pagination">
                                        {this.renderFirstPage()}
                                        {this.renderPages()}
                                        {this.renderNextPage()}
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }
    }
    render() {

        if (!this.state.isAutenticated) {
            return (<Redirect to={'/login'} />)
        }

        let optionItemsTypes = this.state.TypeList.map((item, index) => {
            return <option key={item.ID} className="dropdown-item" href="#" value={item.ID}>{item.Name}</option>
        });

        let optionItemsVersionName = this.state.VersionNameList.map((item, index) => {
            return <option key={item.ID} className="dropdown-item" href="#" value={item.ID}>{item.Name}</option>
        });

        return (
            <div id="divContainer">
                <BlockUi tag="div" blocking={this.state.Data.DataPending} loader={<div className="loader"></div>} >
                    <MainLayout />
                    <div className="container"><ToastContainer hideProgressBar />
                        {
                            this.renderCompanyVersionRow()
                        }
                        <Modal isOpen={this.state.modal.add} toggle={this.toggleAdd}
                            aria-labelledby="contained-modal-title-lg"
                            className={"modal-dialog modal-notify modal-success"}
                        >
                            <ModalHeader toggle={this.toggle}> <p className="heading lead">ADD</p>
                            </ModalHeader>
                            <ModalBody className={"text-center"} style={{ 'maxHeight': 'calc(100vh - 210px)', 'overflowY': 'auto' }}>
                                <div className="row" >
                                    <div className="col-lg-4 col-md-4 col-sm-4">
                                        <label className="control-label" style={{ 'paddingTop': '15px', 'float': 'right', 'fontWeight': 'bold' }}>Company Code</label>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <div className="form-group" style={{ 'paddingTop': '7px' }}>
                                            <input className="form-control" name="Selectcompanycode" id="Selectcompanycode" type="text" onChange={this.hanldeCompanyCode} value={this.state.SelectCompanyCode ? this.state.SelectCompanyCode : ""} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row" >
                                    <div className="col-lg-4 col-md-4 col-sm-4">
                                        <label className="control-label" style={{ 'paddingTop': '15px', 'float': 'right', 'fontWeight': 'bold' }}>Type</label>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <select className="form-control" onChange={this.handleChangeVersion} value={this.state.SelectType}>
                                            <option className="dropdown-item" href="#" value="" >Select</option>
                                            {optionItemsTypes}
                                        </select>
                                    </div>
                                </div>
                                <div className="row" >
                                    <div className="col-lg-4 col-md-4 col-sm-4">
                                        <label className="control-label" style={{ 'paddingTop': '15px', 'float': 'right', 'fontWeight': 'bold' }}>Version</label>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6" >
                                        <select className="form-control" onChange={this.handleChangeVersionName} value={this.state.SelectVersionName} >
                                            <option className="dropdown-item" href="#" value="" >Select</option>
                                            {optionItemsVersionName}
                                        </select>
                                    </div>
                                </div>
                            </ModalBody>
                            <ModalFooter className={"modal-footer justify-content-right"}>
                                <ClipLoader
                                    className={override}
                                    sizeUnit={"px"}
                                    size={30}
                                    color={'#00C851'}
                                    loading={this.state.loading}
                                />
                                {this.state.Button}

                                <Button id="close" color="btn btn-outline-success waves-effect" onClick={this.toggleAdd}>CLOSE</Button>
                            </ModalFooter>
                        </Modal>

                        <Modal isOpen={this.state.modal.warning} toggle={this.toggleWarning}
                            aria-labelledby="contained-modal-title-lg"
                            className={"modal-dialog modal-notify modal-warning"}
                        >
                            <ModalHeader toggle={this.toggle}> <p className="heading lead">Warning</p>
                            </ModalHeader>
                            <ModalBody className={"text-center"} style={{ 'maxHeight': 'calc(100vh - 210px)', 'overflowY': 'auto' }}>
                                <p><FontAwesomeIcon color="#FFBB33" icon={faExclamationTriangle} size="3x" /></p>
                                <p>Are you sure?</p>
                            </ModalBody>
                            <ModalFooter className={"modal-footer justify-content-right"}>
                                <ClipLoader
                                    className={override}
                                    sizeUnit={"px"}
                                    size={30}
                                    color={'#FF8800'}
                                    loading={this.state.loading}
                                />
                                {this.state.Button}
                                {
                                    this.state.loading
                                        ? <a className="btn btn-outline-warning waves-effect disabled" onClick={this.toggleWarning} disabled>CLOSE</a>
                                        : <a className="btn btn-outline-warning waves-effect" onClick={this.toggleWarning}>CLOSE</a>
                                }
                            </ModalFooter>
                        </Modal>
                    </div>
                </BlockUi>
            </div>

        );
    }
}

export default CompanyVersion;



// WEBPACK FOOTER //
// ./src/companyVersions/companyVersions.jsx